import axios from 'axios'
import { serializeParams } from '../utils/genericUtils.js'

export default {
  namespaced: true,
  actions: {
    deleteImage(_, id) {
      return axios({
        url: process.env.VUE_APP_URL + '/student/web/deleteImage/',
        method: 'DELETE',
        params: { id },
      })
    },
    getImage(o, obj) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + '/student/getstimageadmin?id=' + obj,
          method: 'GET',
        })
          .then((response) => {
            if (response.data.status) {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    createStudentPantent(o, obj) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + '/student/web/createBoth',
          data: obj,
          method: 'POST',
        })
          .then((response) => {
            if (response.data.status) {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    createStudent({ rootGetters }, student) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + '/student/web/create',
          data: student,
          method: 'POST',
        })
          .then((response) => {
            if (response.data.status) {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    updateStudent({ rootGetters }, student) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + '/student/web/update',
          data: student,
          method: 'PUT',
        })
          .then((response) => {
            if (response.data.status) {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    getImageOfStudent({ rootGetters }, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + '/student/getstimageadmin?id=' + id,
          method: 'GET',
        })
          .then((response) => {
            if (response.data.status) {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    getQrOfStudent({ rootGetters }, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + '/student/web/QR?id=' + id,
          method: 'GET',
        })
          .then((response) => {
            if (response.data.status) {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getStudentsByBranch(_, filters) {
      return axios({
        url: `${
          process.env.VUE_APP_URL
        }/student/web/getbybranch${serializeParams(filters)}`,
        method: 'GET',
      })
    },
    getSelectedStudentsFirst(_, filters) {
      return axios({
        method: 'GET',
        url: `${process.env.VUE_APP_URL}/student/web/audience${serializeParams(
          filters
        )}`,
      })
    },
    getStudentsForExtraLevels(_, filters) {
      return axios({
        url: `${
          process.env.VUE_APP_URL
        }/student/web/getbybranchforregisters${serializeParams(filters)}`,
        method: 'GET',
      })
    },
    getStudentsFilters() {
      return axios({
        url: `${process.env.VUE_APP_URL}/student/web/getbybranch/filters`,
        method: 'GET',
      })
    },
    getLevelsGradegroups(_) {
      return axios({
        url: `${process.env.VUE_APP_URL}/student/web/getbybranchforregisters/filters`,
        method: 'GET',
      })
    },
    deleteStudents({ rootGetters }, stds) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + '/student/web/deleteV2',
          data: stds,
          method: 'DELETE',
        })
          .then((response) => {
            if (response) {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    toolGetLevelsAndGGs({ rootGetters }) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + '/student/web/levelgg',
          method: 'GET',
        })
          .then((response) => {
            if (response.data.status) {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    // check for available service
    isLocked() {
      return axios({
        url: process.env.VUE_APP_URL + '/studentupgrade/isLocked',
        method: 'GET',
      })
    },
    //Push students
    addStudentWithParents(_, data) {
      return axios({
        url: `${process.env.VUE_APP_URL}/studentupgrade/web/importStudentWithParent`,
        method: 'POST',
        data,
      })
    },

    //Push DB
    addStudentWithParentsNextStep(_, obj) {
      return axios({
        url:
          process.env.VUE_APP_URL +
          '/studentupgrade/web/importStudentsWithParentsNextStep',
        data: obj,
        method: 'POST',
      })
    },

    //Edit Student
    updateStudentUpdate({ rootGetters }, student) {
      return new Promise((resolve, reject) => {
        axios({
          url:
            process.env.VUE_APP_URL + '/studentupgrade/student/' + student.id,
          data: student,
          method: 'PUT',
        })
          .then((response) => {
            if (response.data.status) {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    //Edit Parent
    updateParentUpdate({ rootGetters }, parent) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + '/studentupgrade/parent/' + parent.id,
          data: parent,
          method: 'PUT',
        })
          .then((response) => {
            if (response.data) {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getUpdatedSudents(_, [idFileUpgrade, params]) {
      return axios({
        url: `${
          process.env.VUE_APP_URL
        }/studentupgrade/${idFileUpgrade}/students${serializeParams(params)}`,
        method: 'GET',
      })
    },

    getStudentsByBranchToPdf(_, filters) {
      return axios({
        headers: {
          accept: 'application/octet-stream',
          responseType: 'blob',
          'content-type': 'application/octet-stream',
        },
        url: `${
          process.env.VUE_APP_URL
        }/student/web/exportStudentsTemplate${serializeParams(filters)}`,
        method: 'GET',
        responseType: 'blob',
        'content-type': 'application/octet-stream',
        accept: 'application/octet-stream',
      })
    },

    getStudentsParentsByBranchToCsv(_, filters) {
      return axios({
        headers: {
          Accept: 'application/octet-stream',
          'Content-Type': 'application/octet-stream',
        },
        url: `${
          process.env.VUE_APP_URL
        }/student/web/exportStudentWithParent${serializeParams(filters)}`,
        method: 'GET',
        responseType: 'blob',
      })
    },

    getStudentsByBranchToCsv(_, filters) {
      return axios({
        headers: {
          Accept: 'application/octet-stream',
          'Content-Type': 'application/octet-stream',
        },
        url: `${
          process.env.VUE_APP_URL
        }/student/web/exportStudentsTemplate${serializeParams(filters)}`,
        method: 'GET',
        responseType: 'blob',
      })
    },
    getXlsxStudentsExtra(_, params) {
      return axios({
        headers: {
          Accept: 'application/octet-stream',
          'Content-Type': 'application/octet-stream',
        },
        url: `${
          process.env.VUE_APP_URL
        }/student/web/extra/exportStudentsTemplate${serializeParams(params)}`,
        method: 'GET',
        responseType: 'blob',
      })
    },
    importStudents({ rootGetters }, students) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + '/student/web/importStudents',
          data: students,
          method: 'POST',
        })
          .then((response) => {
            if (response.data.status) {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    importStudentsExtra({ rootGetters }, students) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + '/student/web/importStudentsExtras',
          data: students,
          method: 'POST',
        })
          .then((response) => {
            if (response.data.status) {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    unlinkStudentsLevelExtra(o, student) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + '/student/web/unlinkExtra',
          data: student,
          method: 'PUT',
        })
          .then((response) => {
            if (response.data.status) {
              resolve(response.data)
            } else {
              reject(response.data)
            }
          })
          .catch((error) => {
            reject(error.data)
          })
      })
    },
    linkStudentsLevelExtra(o, students) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + '/student/web/linkExtra',
          data: students,
          method: 'PUT',
        })
          .then((response) => {
            if (response.data.status) {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    updateParentPaymentData(o, students) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + '/student/web/updateParentPaymentData',
          data: students,
          method: 'PUT',
        })
          .then((response) => {
            if (response.data.status) {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getByBranch(o, params) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + '/student/web/tool/byBranch',
          method: 'GET',
          params: params,
        })
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    toggleMultipleQRStatus(o, params) {
      return axios({
        url: `${process.env.VUE_APP_URL}/student/toggleqrstatus`,
        data: params,
        method: 'PUT',
      })
    },
    blockQR(_, obj) {
      return axios({
        url: `${process.env.VUE_APP_URL}/student/${obj.id}/toggleqrstatus`,
        method: 'PUT',
        data: {
          reason: obj.reason,
          disable: obj.disable,
          start: obj.start,
          end: obj.endDate,
          reasonType: obj.reasonType,
        },
      })
    },
    getStudentQRPdf(_, params) {
      return axios({
        headers: {
          accept: 'application/octet-stream',
          responseType: 'blob',
          'content-type': 'application/octet-stream',
        },
        url: `${
          process.env.VUE_APP_URL
        }/student/web/downloadstudentqr${serializeParams(params)}`,
        method: 'GET',
        responseType: 'blob',
        'content-type': 'application/octet-stream',
        accept: 'application/octet-stream',
        'Access-Control-Allow-Origin': '*',
        userType: 'W',
      })
    },
    getQrImgStudent(_, params) {
      return axios({
        headers: {
          accept: 'application/octet-stream',
          responseType: 'blob',
          'content-type': 'application/octet-stream',
        },
        url: `
          ${
            process.env.VUE_APP_URL
          }/student/web/downloadImageQr${serializeParams(params)}
        `,
        method: 'GET',
        responseType: 'blob',
        'content-type': 'application/octet-stream',
        accept: 'application/octet-stream',
        'Access-Control-Allow-Origin': '*',
        userType: 'W',
      })
    },
    getQrImgExtraStudent(_, params) {
      return axios({
        headers: {
          accept: 'application/octet-stream',
          responseType: 'blob',
          'content-type': 'application/octet-stream',
        },
        url: `${
          process.env.VUE_APP_URL
        }/student/web/extra/downloadImageQr${serializeParams(params)}`,
        method: 'GET',
        responseType: 'blob',
        'content-type': 'application/octet-stream',
        accept: 'application/octet-stream',
        'Access-Control-Allow-Origin': '*',
        userType: 'W',
      })
    },
    getExtraStudentQrPdf(_, params) {
      return axios({
        headers: {
          accept: 'application/octet-stream',
          responseType: 'blob',
          'content-type': 'application/octet-stream',
        },
        url: `${
          process.env.VUE_APP_URL
        }/student/web/extra/downloadstudentqr${serializeParams(params)}`,
        method: 'GET',
        responseType: 'blob',
        'content-type': 'application/octet-stream',
        accept: 'application/octet-stream',
        'Access-Control-Allow-Origin': '*',
        userType: 'W',
      })
    },
    getStudentsBirthdates(_, params) {
      return axios({
        url: `${process.env.VUE_APP_URL}/student/birthday${serializeParams(
          params
        )}`,
        method: 'GET',
      })
    },
    getStudentsBirthdatesXlsx(_, params) {
      return axios({
        headers: {
          Accept: 'application/octet-stream',
          'Content-Type': 'application/octet-stream',
        },
        url: `${process.env.VUE_APP_URL}/student/birthday/xlsx${serializeParams(
          params
        )}`,
        method: 'GET',
        responseType: 'blob',
      })
    },
  },
}
